<template>
    <div>
        <div class="bot-message"> 
            <div class="bot-message-body">
                <div class="bot-content">
                    {{ message }}
                </div>
                <div v-if="attachment" class="attachment">
                    <v-img :lazy-src="attachment.url" max-height="250" max-width="250" :src="attachment.url" v-if="attachment.type == 'image'"></v-img>
                </div>
                <div class="bot-time">
                    {{ time }}
                </div>
            </div>
            <div v-if="actions">
                <div class="btn-container" v-for="(action, index) in actions" :key="index">
                    <v-btn class="button-rounding" color="info" v-if="action.type == 'button'" outlined @click="performAction(action.value, message.original)">
                        <v-icon v-if="action.value == 'buy'" left>
                            mdi-cart
                        </v-icon>
                        {{ action.text }}
                    </v-btn>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import moment from 'moment'
export default {
    props: {
        content: Object
    },
    computed: {
        type() {
            return this.content.type
        },
        message: {
            get() {
                return this.content.text
            }
        },
        time: {
            get() {
                return this.content.time
            }
        },
        attachment: {
            get() {
                return this.content.attachment
            }
        },
        actions() {
            return this.content.actions
        }
    },
    methods: {
        buttonClicked(value) {
            const data = {
                author: 'user',
                message: value,
                time: moment().locale('ve').format('hh:mm:ss a')
            }
            this.$store.dispatch('message/sendMessage', data)
        },
        
        }
    }
</script>
<style lang="scss">
    .bot-message {
        display: inline-block;
        margin-bottom: 3px;

        .attachment {
            margin: 0;
            padding: 0;
            img {
                max-width: 100%;
            }
            .bot-time {
                color: #000;
                text-align: right;
                padding: 5px;
                font-size: 10px;
                margin: 0px 10px 5px 10px;
            }
        }
        
        .bot-message-body {
            background-color: #66BB6A;
            border-radius: 7px 7px 7px 0px;

            .bot-content {
                padding: 10px;
                margin: 5px;
                color: white;
            }
            .bot-time {
                color: #FAFAFA;
                text-align: right;
                padding: 5px;
                font-size: 10px;
                margin: 0px 10px 5px 10px;
            }
        }
    }
    
    .btn-container {
        display: flex;
        flex-wrap: wrap;
    }
</style>
